export default __webpack_public_path__ + "0e4590be6245977d6df4d2564b3eda54.svg";